
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[locale]/about-us",
      function () {
        return require("private-next-pages/[locale]/about-us/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[locale]/about-us"])
      });
    }
  